import { RowOptionsCell } from 'components/Settings/Components/RolesManagement/components/RowOptionCell';
import { DefaultColumnFilter } from 'components/common/Tables/ColumnFilter/ColumnFilter';
import { columnsCommonConfig } from 'components/common/Tables/columnsCommonConfig';

import { customCaseSensitiveSort } from 'components/common/Tables/Tables.utils';

export const defaultColumn = {
    Filter: DefaultColumnFilter,
};

export const initialState = {
    sortBy: [
        {
            id: 'label',
        },
    ],
};

export const columns = [
    {
        Header: 'Role name',
        accessor: 'label',
        width: 1285,
        sortType: customCaseSensitiveSort,
    },
    {
        Header: '',
        ...columnsCommonConfig.rowOptions,
        Cell: ({ row }) => {
            return <RowOptionsCell row={row} />;
        },
    },
];
